import React from 'react';
import { documentConfig } from '../../constants/documentConfig';
import { dotColor } from './scoreColor';

const DocumentNavigator = ({
  results,
  loadingDocTypes,
  activeDocType,
  onSelect,
  isGenerating,
  totalSelected,
  totalDone,
  progressPct,
  onNewGeneration,
}) => {
  return (
    <div className="results-doc-nav">
      <div className="doc-navigator-header">
        <span>Generated Documents</span>
        {totalSelected > 0 && (
          <span className="doc-nav-count">
            {totalDone}/{totalSelected}
          </span>
        )}
      </div>

      {/* Progress bar while generating */}
      {isGenerating && totalSelected > 0 && (
        <div className="doc-nav-progress">
          <div
            className="doc-nav-progress-fill"
            style={{ width: `${progressPct}%` }}
          />
        </div>
      )}

      <div className="doc-navigator-list">
        {results.map((result) => {
          const label = documentConfig[result.docType]?.label || result.docType;
          const score = result.atsOverall;
          const fixCount = result.fixPanel?.length || 0;
          const meta = result.failed
            ? "Couldn't be generated"
            : score != null
              ? `${Math.round(score)}% ATS · ${fixCount > 0 ? `${fixCount} tip${fixCount !== 1 ? 's' : ''}` : 'Ready'}`
              : 'Ready';
          const isActive = result.docType === activeDocType;

          return (
            <button
              key={result.docType}
              className={`doc-nav-item ${isActive ? 'doc-nav-item--active' : ''}`}
              onClick={() => onSelect(result.docType)}
            >
              <div className="doc-nav-item-top">
                <span
                  className="doc-nav-dot"
                  style={{ background: result.failed ? 'var(--score-red)' : dotColor(score) }}
                />
                <span className="doc-nav-name">{label}</span>
              </div>
              <div className="doc-nav-meta">{meta}</div>
            </button>
          );
        })}

        {(loadingDocTypes || []).map((docType) => (
          <div key={`loading-${docType}`} className="doc-nav-loading-row">
            <div className="doc-nav-spinner" />
            <span>{documentConfig[docType]?.label || docType}</span>
          </div>
        ))}
      </div>

      {/* New Generation button at bottom of nav */}
      {onNewGeneration && !isGenerating && (
        <div className="doc-nav-footer">
          <button className="doc-nav-new-btn" onClick={onNewGeneration}>
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <line x1="12" y1="5" x2="12" y2="19" />
              <line x1="5" y1="12" x2="19" y2="12" />
            </svg>
            New Generation
          </button>
        </div>
      )}
    </div>
  );
};

export default DocumentNavigator;
